export var languagesList = ['en', 'uk', 'ru', 'nl', 'tr', 'fr', 'es', 'de'];
export var ENGLISH = 'en';
export var GERMAN = 'de';
